module.exports = __webpack_public_path__ + "static/img/14.88e7972.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/14.png
// module id = 9ITN
// module chunks = 0